<script type="text/ecmascript-6">
    import DesignerQuestionHardwareHandleWithSuite from "../DesignerQuestionHardwareHandleWithSuite.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareHandleWithSuite
        ],
        props: {
            title: {
                default() {
                    return 'Select Your Door Handle';
                }
            }
        }
    }
</script>
